import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import Organizations from "./organizations";
import Organization from "./organization";
import { withTranslation } from "react-i18next";

class OrganizationAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          tabSetEnableTabStrip: false,
          children: [
            {
              type: "tab",
              name: this.props.t("Organizations"),
              enableClose: false,
              component: "Organizations",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleOrganizationSelect = (Organization, submitCallbackFunction, isNew) => {
    const { organizationId, name } = Organization;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "Organization",
            name: `${name}`,
            id: `${organizationId}`,
            config: { organizationId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(organizationId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const OrganizationId = node.getId();

    if (componentId === "Organizations") {
      return (
        <Organizations
          onClick={this.handleOrganizationSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Organization") {
      const { organizationId, submitCallbackFunction, isNew } =
        node.getConfig();
      return (
        <Organization
          organizationId={organizationId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container auth-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["auth"])(OrganizationAdmin);
